import React, { createContext, useState } from "react";

export const ProfileContext = createContext();

export default function ProfileContextProvider({ children }) {
    const [profile, setProfile] = useState(false);

    return (
        <ProfileContext.Provider value={{ profile, setProfile }}>
            {children}
        </ProfileContext.Provider>
    );
}
